<template>
    <div>
        <div class="pay-wrap">
            <div class="content">
                
                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">订单编号</span>
                        <span class="text">{{ orderNo }}</span>
                    </div>
                  
                   
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ price  }}USDT</span>
                    </div>

                    <div class="info-list">
                        <span class="label">数量</span>
                       
                        <a-input
                            style="width:80px;text-align:right"
                            v-model:value="quantity"
                            placeholder="1"
                            class="amount-input"
                            size="large"
                            />
                    </div>
                    
                </div>

                <div class="pay-list">
                    <p class="title">选择付款钱包</p>
                    <div v-for="(item, index) in payList" :key="index" class="item">
                        <div class="img-wrap">
                            <img :src="item.src" alt="">
                            <span class="title">{{ item.title }}</span>
                        </div>
                        <a-radio-group v-model:value="checkedVal">
                            <a-radio :value="item.value"></a-radio>
                        </a-radio-group>
                    </div>
                    <div class="btn-wrap">
                        <a-button class="btn" @click="onPay" type="primary">打开支付</a-button>
                    </div>
                </div>
            </div>
        </div>
         <!-- 二维码弹窗 -->
         <a-modal v-model:visible="qrVisible" title="比特派钱包支付" @ok="qrVisible = false" @cancel="qrVisible = false">
            <div class="qr-modal-content">
                <p class="qr-tips">请使用比特派钱包扫描下方二维码完成支付</p>
                <div class="qr-code-wrapper">
                    <canvas ref="qrCanvas"></canvas>
                </div>
                <p class="qr-tips">或复制以下链接到比特派钱包中打开:</p>
                <a-input v-model:value="bitpieUrl" readonly class="qr-input">
                    <template #addonAfter>
                        <a-button type="text" @click="copyUrl">复制</a-button>
                    </template>
                </a-input>
            </div>
        </a-modal>
    </div>
</template>

<script>
// import { testTX } from '../util/tronweb'; 
import { updateOrder } from "../util/api"
import QRCode from 'qrcode';


export default {
    name: 'PaymentPage',
    props: {
        msg: String
    },
    components: {
    },
    data() {
        return {
            orderNo:"",
            price:"",
            quantity:1,
            checkedVal: '',
            referralCode:'',
            tgNo:'',
            payList: [
                { title: 'imToken钱包', src: require('../assets/imtoken.jpg'), value: 'imtoken', checked: false },
                { title: 'Tokenpocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket', checked: true },
                { title: 'BitGet钱包', src: require('../assets/bitget.jpg'), value: 'bitget', checked: false },
                { title: 'TronLink钱包', src: require('../assets/tronlink.jpg'), value: 'tronlink', checked: false },
                // { title: '比特派钱包', src: require('../assets/biep.png'), value: 'bitpie', checked: false },
            ]
        }
    },
    mounted() {
        
        const orderNo = this.$route.query.orderNo;
        const price = this.$route.query.price;
        const referral_code = this.$route.query.referral_code;
        this.orderNo = orderNo;
        this.price = price;
        this.referralCode = referral_code;
        this.tgNo = orderNo;

        if (window.tronWeb && window.tronWeb.ready) {
            console.log("✅ TronLink 发现！");
            //this.$router.push({ name: 'walletPay', params: { tgNo: this.tgNo,referralCode:this.referralCode } });
            this.$router.push({ 
                path: `/walletPay/tgNo/${this.tgNo}/referralCode/${this.referralCode}` 
            });
            
        } else {
            console.error("❌ 未安装 TronLink");
        }

    },
    methods: {
        getUserApploenMethod() {
            // 
        },
        onCheck(val) {
            this.checkedVal = val
        },
        async onPay() {
             // 1. 检查是否拥有 TronLink 注入
             // 根据钱包的选择链接到不同的钱包
            //添加订单
            //先修改订单的数量和金额
            //const money = this.price * this.quantity;
            let data = {
                orderNo:this.orderNo,
                quantity:this.quantity,
            }
            await updateOrder(data);

  
            if (this.checkedVal == 'imtoken') {
                // 生成动态路径参数的 URL
               // 构建深链接
                const dynamicPath = `https://client.uekcdt.top/walletPay/tgNo/${this.tgNo}/referralCode/${this.referralCode}`;
               //const dynamicPath = "https://www.google.com/"
               const deeplink = `imtokenv2://navigate/DappView?url=${dynamicPath}`;
                console.log(deeplink);
                // 跳转
                window.location.href = deeplink;
            }else if(this.checkedVal == 'tokenpocket'){
                const dynamicPath = `https://client.uekcdt.top/walletPay/tgNo/${encodeURIComponent(this.tgNo)}/referralCode/${encodeURIComponent(this.referralCode)}`;
                //const dynamicPath = "https://www.google.com/"
                console.log(dynamicPath)
                let param = {}
                param = {
                "url":dynamicPath,
                "chain": "Tron",
                "source": "shopSer"
                }

            // 2. 将对象转为JSON字符串后再进行URL编码
                const encodedParam = encodeURIComponent(JSON.stringify(param),"utf-8");

                //const deeplink = `tpoutside://pull.activity?param=${encodedParam}`;
                const deeplink = `tpdapp://open?params=${encodedParam}`;
                console.log(deeplink);
                // 跳转
                window.location.href = deeplink;
                
            }else if(this.checkedVal == 'bitget'){  
                const dynamicPath = `https://client.uekcdt.top/walletPay/tgNo/${this.tgNo}/referralCode/${this.referralCode}`;
                           
                const deeplink = `https://bkcode.vip?action=dapp&url=${dynamicPath}`
                // 跳转
                window.location.href = deeplink;
               
            }else if(this.checkedVal == 'tronlink'){
               const dynamicPath = `https://client.uekcdt.top/walletPay/tgNo/${this.tgNo}/referralCode/${this.referralCode}`;
              // const dynamicPath = `https://xiaotiankfbot.com:8443/walletPay/tgNo/888835/referralCode/${encodeURIComponent(this.referralCode)}`;
              
            // 1. 将对象转为JSON字符串
                // 2. 进行URL编码
                const encodedUrl = encodeURIComponent(dynamicPath);

                const deeplink = `tronlinkapp://open?url=${encodedUrl}`;
                // 跳转
                 window.location.href = deeplink;
            }else if(this.checkedVal == 'bitpie'){
                this.bitpieUrl = `https://client.uekcdt.top/walletPay/tgNo/${this.detail.orderNo}/referralCode/${this.referralCode}`;

                 // 显示二维码弹窗
                 this.qrVisible = true;
                
                // 生成二维码
                this.$nextTick(() => {
                    QRCode.toCanvas(this.$refs.qrCanvas, this.bitpieUrl, {
                        width: 200,
                        margin: 2
                    }, (error) => {
                        if (error) console.error(error);
                    });
                });
            }

            //getUserApploen();
            //getUserApploen()
            // this.getUserApploenMethod()
        },
    }
}
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .tips {
            padding: 20px 0px 10px;
            line-height: 22px;
            margin-bottom: 0;
            font-size: 16px;
            text-align: center;
        }

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;

            .title {
                font-weight: bold;
            }

            .item {
                display: flex;
                align-items: center;
                height: 60px;
                justify-content: space-between;
                border-bottom: #f8f8f8 2px solid;
            }

            .img-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    margin-right: 16px;
                }
            }
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                width: 100%;
                margin-top: 20px;
            }
        }

    }
}
</style>
